import React from "react"
import { getLaunchTime, isVideo, redirectToOmnicuris } from "../utilities"
import ReadMore from "./ReadMore"
import ReactPlayer from "react-player"
import ArrowIcon from "../assets/images/ArrowIconWhite.svg"
import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import ExpertsList from "./ExpertsList"

function StandAloneWebinar(props) {
  const { items, courseId, courseSlug, platformType } = props
  const { domainDetails } = useSelector((state) => state.listings)

  const history = useHistory()

  const redirectTo = (ev) => {
    ev.stopPropagation()
    // if (domainDetails && domainDetails.orgType === 'certifier') {
    //   if (items.webinar.completed) {
    //     if (platformType === 'CME') {
    //       redirectToOmnicuris(`/academics/${courseSlug}/${items.webinar.seriesId}/${items.webinar.id}`, window.self != window.top);
    //     } else {
    //       redirectToOmnicuris(`/oc-originals/${courseSlug}/${items.webinar.seriesId}/${items.webinar.id}`, window.self != window.top);
    //     }
    //   } else {
    //     redirectToOmnicuris(`/oc-live/${items.webinar.id}`, window.self != window.top);
    //   }
    // } else {
    if (items.webinar.completed) {
      history.push(`/academics/${courseSlug}/${items.webinar.seriesId}/${items.webinar.id}`)
    } else {
      history.push(`/live/${items.webinar.id}`)
    }
    // }
  }

  return (
    <div className="standAloneWebinar">
      <section>
        <p>
          <ReadMore charLimit={400} content={items.webinar && items.webinar.description} showAsHTML={false} />
        </p>
        {items.webinar && items.webinar.experts.length > 0 && <ExpertsList experts={items.webinar.experts} limit={3} />}

        <button className="registerButton" onClick={redirectTo}>
          {items.webinar && items.webinar.completed ? "Watch Now" : "Register now"} <img src={ArrowIcon} alt="" />
        </button>
      </section>
      <div className="webinarsDetails">
        <div className="webinarsMedia">
          {isVideo(items.webinar && (items.webinar.webinarWebBannerUrl ? items.webinar.webinarWebBannerUrl : items.webinar.webinarAppBannerUrl)) ? (
            <ReactPlayer url={items.webinar && (items.webinar.webinarWebBannerUrl ? items.webinar.webinarWebBannerUrl : items.webinar.webinarAppBannerUrl)} controls={true} muted={true} playsinline={true} width="100%" height="100%" />
          ) : (
            <figure>
              <img src={items.webinar && (window.innerWidth <= 768 ? items.webinar.webinarAppBannerUrl : items.webinar.webinarWebBannerUrl ? items.webinar.webinarWebBannerUrl : items.webinar.webinarAppBannerUrl)} alt="" />
            </figure>
          )}
          <div className={`tags ${items.webinar.completed ? "tagsGreen" : "tagsOrange"}`}>{items.webinar.completed ? "Completed" : "Upcoming"}</div>
        </div>
        <div className="webinarsCardsFooter">
          {items.webinar && items.webinar.experts.length > 0 && <ExpertsList experts={items.webinar.experts} limit={2} />}
          <div className="webinarsLaunchDate">{getLaunchTime(items.webinar.launchTime)}</div>
        </div>
      </div>
    </div>
  )
}

export default StandAloneWebinar
